import {
  Smartphone,
  Timer,
  UserCheck,
  RefreshCw,
  CalendarDays,
  Hash,
  TrendingUp,
  Rocket,
  CalendarRange,
  ShieldCheck,
  BarChart3,
  Lock,
  Clock,
} from "lucide-react";
import FeaturePageLayout from "./FeaturePageLayout";
import attendanceHeroImg from "../../assets/images/features/attendance-hero.png.png";

const workflowSteps = [
  { id: 1, title: "Smart Check-In/Out", desc: "Employees log time via supported attendance methods configured by your organization.", icon: Smartphone },
  { id: 2, title: "Real-Time Processing", desc: "System automatically logs working hours, late arrivals, early departures, and overtime.", icon: Timer },
  { id: 3, title: "Manager Approval", desc: "Approvers easily review logs, rectify anomalies, and clear pending entries instantly.", icon: UserCheck },
  { id: 4, title: "Seamless Payroll Sync", desc: "Data routes straight to payroll modules, securing accurate salary computations.", icon: RefreshCw },
];

const keyBenefits = [
  { title: "Daily Attendance Management", desc: "Effortlessly track daily staff clock-ins and operational status updates.", icon: CalendarDays },
  { title: "Precise Working Hour Calculation", desc: "Eliminate discrepancies with automated calculations of active work times.", icon: Hash },
  { title: "Automated Overtime Tracking", desc: "Seamlessly log additional shifts, custom intervals, and premium hours.", icon: TrendingUp },
  { title: "Improved Workforce Productivity", desc: "Optimize overall shift schedules and eliminate administrative bottlenecks.", icon: Rocket },
];

const coreCapabilities = [
  { title: "Holiday Calendar Support", desc: "Incorporate localized holidays, weekly off-days, and custom shifts.", icon: CalendarRange },
  { title: "Approval Workflows", desc: "Configurable review pathways ensuring full manager alignment.", icon: ShieldCheck },
  { title: "Advanced Attendance Reports", desc: "Extract on-demand workforce analytics filtered by department or individual.", icon: BarChart3 },
  { title: "Secure Audit Trails", desc: "Keep all historical logs protected and fully accessible for external audits.", icon: Lock },
];

export default function AttendanceTracking() {
  return (
    <FeaturePageLayout
      featureName="Attendance Tracking"
      title="Attendance Tracking"
      description="Monitor employee working hours accurately and efficiently. Brixigo provides a centralized attendance management system designed to log daily operational presence, streamline approvals, and drive organization-wide productivity."
      heroImage={attendanceHeroImg}
      heroImageAlt="Attendance tracking — workforce time and check-in illustration"
      workflowHeading="How Attendance Tracking Works"
      workflowSteps={workflowSteps}
      benefits={keyBenefits}
      included={coreCapabilities}
      includedHeading="Core Capabilities"
      ctaIcon={Clock}
      ctaTitle="Streamline Time Tracking. Maximize Efficiency."
      ctaDescription="Eliminate manual log errors and align your staff operations seamlessly with automated processing."
      ctaButtonLabel="Book a Demo"
    />
  );
}
